enum BiteServiceName {
  BuildAndDeploy = 'build-and-deploy',
  Bureau = 'bureau',
  Clock = 'clock',
  DbCollectionWatcher = 'db-collection-watcher',
  Flash = 'flash',
  Garcon = 'garcon',
  Maitred = 'maitred',
  QueueConsumerInternal = 'queue-consumer-internal',
  QueueConsumerOperational = 'queue-consumer-operational',
  QueueConsumerOrders = 'queue-consumer-orders',
  QueueConsumerQuicksand = 'queue-consumer-quicksand',
  QueueConsumerQuicksandSmall = 'queue-consumer-quicksand-small',
  QueueConsumerWebhooks = 'queue-consumer-webhooks',
  RecommendationApp = 'recommendations',
  Scripts = 'scripts',
  Vitrine = 'vitrine',
  WebhookReceiver = 'webhook-receiver',
}

export { BiteServiceName };
